import {cn} from '../../lib/utils';
import {Button} from '../Button';
import {DirectionalIcon} from '../DirectionalIcon';

import type {FC} from 'react';

export interface NavHistoryButtonProps {
  direction: 'back' | 'forward';
  onClick: () => void;
  ariaLabel: string;
  disabled?: boolean;
  className?: string;
}

export const NavHistoryButton: FC<NavHistoryButtonProps> = ({
  direction,
  onClick,
  ariaLabel,
  disabled,
  className
}) => (
  <Button
    data-slot={direction === 'back' ? 'back-button' : 'forward-button'}
    variant="secondary"
    size="icon-xs"
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled}
    icon={<DirectionalIcon name={direction === 'back' ? 'arrow-back' : 'arrow-forward'} />}
    className={cn('disabled:opacity-50', className)}
  />
);
